import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../services/user/user.service';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
declare const $: any;

@Component({
  selector: 'login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {
  @Output() hideLoginForm = new EventEmitter();

  loginForm: FormGroup;
  showResetForm = false;

  constructor(private formBuilder: FormBuilder,
    private _user: UserService,
    private router: Router,
    private title: Title) { }

  ngOnInit() {
    this.initLoginForm();

  }
  initLoginForm() {
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.email],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  login() {
    if (!this.loginForm.valid) {
      this.markFormGroupTouched(this.loginForm);
      return;
    }
    const loginInfo = this.loginForm.value;
    this._user.login(loginInfo).then((data: any) => {
      this.router.navigate(['/dashboard']);
      $('#registerModal').modal('hide');
    }).catch((err) => {
      console.log(err);
    });
  }

  backToSignUp() {
    this.hideLoginForm.emit(true);
  }

  changeStatusResetModal(status) {
    if (status) {
      this.showResetForm = false;
    }
  }

  markFormGroupTouched(formGroup: FormGroup) {
    return (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        control.controls.forEach(c => this.markFormGroupTouched(c));
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/login-form/login-form.component.ts